<template>
    <section>
        <div>
            <header-page
				name="tasks"
				:title="$route.meta.title"
			/>
			<div class="px-5">
			<app-table class="my-5 is-not-selectable pb-4" name="projects" :columns="columns" :current-page="currentPage"
				:rows="rows" :last-page="lastPage" @on-search-event="onSearch" @on-page="changePage">
				<template slot="rows" slot-scope="props">
						<td
							class="is-not-selectable"
							v-show="showRow(columns, 1)"
						>
							{{ props.row.taskOrder }}
						</td>
						<td v-show="showRow(columns, 2)">
							{{ props.row.description }} 
						</td>
						<td v-show="showRow(columns, 3)">
							{{ props.row.uriWeb }}
						</td>
						<td v-show="showRow(columns, 4)">
							{{ props.row.uriMobile }}
						</td>
						<td v-show="showRow(columns, 5)">
							{{ props.row.method }}
						</td>
						<td v-show="showRow(columns, 6)">
							{{ props.row.code }}
						</td>
						<td v-show="showRow(columns, 7)">
							{{ props.row.module }}
						</td>
						<td v-show="showRow(columns, 8)" class="d-flex align-center">
							<app-tooltip-button
								color="blue"
								icon="edit"
								text="Editar"
								@click-icon="edit(props.row)"
							/>
							<app-tooltip-button
								color="red"
								icon="delete"
								text="Elimnar"
								@click-icon="openModalConfirmation(props.row)"
							/>
							<v-tooltip top>
								<v-switch
									slot="activator"
									color="green"
									class="mt-0 ml-2"
									hide-details
									v-model="props.row.flagActive"
									@change="blockedTask(props.row)"
								></v-switch>
								<span class="text-center">{{ props.row.flagActive ? 'Desactivar' : 'Activar' }} tarea</span>
							</v-tooltip>
						</td>
					</template>
			</app-table>
		</div>
            <quick-actions
				:actions="actions"
				@open-modal="openModal"
			>
			</quick-actions>
        </div>
		<app-confirmation-modal
			:loading="loading"
			:show-modal="modalConfirmation.value"
			@cancel="cancelModalConfirmation"
			@confirm="confirm()"
		/>
	<router-view></router-view>
        <router-view></router-view>

    </section>
</template>

<script>
import quickActions from '@/components/shared/quick-actions';
import appTooltipButton from '@/components/shared/app-tooltip-button';
import appConfirmationModal from '@/components/shared/app-confirmation-modal';


function openModal() {
	this.goTo('page-new-task');
}
function edit({ id }) {
	this.goTo('page-edit-task', { params: { taskId: id, id: this.id } });
}

async function confirm() {
	try {
		const headers = {
			Accept: `${process.env.ACCEPT_SERVICE_V2}`,
		};
		await this.$http.delete(`task/${this.modalConfirmation.selectedRow.id}`, { headers });
		this.showNotification('El nivel se elimino correctamente');
		this.cancelModalConfirmation();
		this.loadData();
	} catch (error) {
		this.showError();
	}
}

async function loadData() {
	try {
		const params = this.params;
		params.levelId = this.id;
		const headers = {
			Accept: `${process.env.ACCEPT_SERVICE_V2}`,
		};
		const response = await this.$http.get('task', { params, headers });
		this.rows = response.data.data;
		this.lastPage = Number(response.headers['x-last-page']);
	} catch (error) {
		this.showError();
	}
}

function changePage(page) {
	this.currentPage = page;
	this.params.page = page;
	this.loadData();
}

function onSearch(search) {
	this.params.search = search ? search.trim() : null;
	this.loadData();
}
function created() {
	this.loadData();
}

function data() {
	return {
		actions: [
			{
				id: 1,
				code: 'TSK',
				text: 'Agregar Tarea',
				img: '',
				active: true,
			},
		],
		columns: [
			{ id: 1, name: 'Tarea', checked: true, visible: true },
			{ id: 2, name: 'Descripcion', checked: true, visible: true },
			{ id: 3, name: 'Uri Web', checked: true, visible: true },
			{ id: 4, name: 'Uri Mobile', checked: true, visible: true },
			{ id: 5, name: 'Metodo', checked: true, visible: true },
			{ id: 6, name: 'Codigo', checked: true, visible: true },
			{ id: 7, name: 'Modulo', checked: true, visible: true },
			{ id: 8, name: '', checked: true, visible: true, flagVisible: true },
		],
		currentPage: 1,
		lastPage: 0,
		rows: [],
		loading: false,
		params: {
			page: 1,
			codeProject: this.codeProject,
		},
	};
}

export default {
	name: 'page-tasks-level',
	data,
	created,
	components: {
		appTooltipButton,
		quickActions,
		appConfirmationModal,
	},
	methods: {
		openModal,
		edit,
		loadData,
		changePage,
		onSearch,
		confirm,
		async blockedTask(row) {
			const body = { ...row };
			const message = body.flagActive ? 'activo' : 'desactivo';
			body.flagActive = body.flagActive ? 1 : 0;
			const headers = {
				Accept: `${process.env.ACCEPT_SERVICE_V2}`,
			};
			try {
			body.flagActive = body.flagActive ? 1 : 0;
			body.flagActive = body.flagActive ? 1 : 0;
				await this.$http.patch(`task/${body.id}`, body, { headers });
				this.showNotification(`Se ${message} la tarea`);
			} catch (error) {
				this.showNotification('No se pudo bloquear la tarea', 'error');
			}
		},
	},
	props: {
		id: {
			type: [Number, String],
		},
		codeProject: {
			type: String,
		},
	},
	watch: {
		$route(newVal) {
			if (newVal) {
				if (newVal.name === 'page-tasks-level') {
					this.loadData();
				}
			}
		},
	},
};

</script>


// WEBPACK FOOTER //
// src/pages/task/page-task.vue